import "../../../constants/index.js";
import { transformWithSpec } from "../../../utils/response.js";
import { require200Status } from "../../utils/response.js";
import { FundingMethodConvertSpec } from "../../../types/models/funding.specs.js";
function depositMethodEndpoints(builder) {
  return {
    getDepositMethods: builder.query({
      providesTags: ["deposit-methods"],
      query: () => ({
        url: `/member/deposit-methods`,
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec(FundingMethodConvertSpec)
    })
  };
}
export {
  depositMethodEndpoints as default
};
